module.exports = __webpack_public_path__ + "img/abacusvideo.44486477.png";